<span [class]="getBadgeStyle()">{{ status }}</span>